import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import useWindowSize from '@nubank/www-latam-commons/utils/hooks/useWindowSize';

import { useSiteContext } from '../SiteContext/SiteContext';
import { headerCTARegisterEvent } from '../../screens/Registration/tracking';

import { CTAButton } from './styles/CTAButton';

const FAQHeader = ({ buttonLabel }) => {
  const [isInFold, setIsInFold] = useState(true);
  const { height } = useWindowSize();
  const { openRegistrationForm } = useSiteContext();

  function handleScrollPosition() {
    if (window.innerWidth > 768) {
      setIsInFold(false);
      return;
    }

    const yPosition = window.scrollY;
    const foldHeight = height;
    const isInFoldRange = yPosition <= foldHeight;

    setIsInFold(isInFoldRange);
  }

  useEffect(() => {
    handleScrollPosition();
    window.addEventListener('scroll', handleScrollPosition, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScrollPosition);
    };
  }, []);

  const openForm = () => {
    openRegistrationForm();
    headerCTARegisterEvent();
  };

  return (
    <CTAButton
      extended
      isHidden={isInFold}
      variant="contained"
      color="primary"
      onClick={openForm}
      intlKey={buttonLabel}
    />
  );
};

FAQHeader.defaultProps = {
  buttonLabel: 'HOME.HERO.BUTTON_LABEL',
};

FAQHeader.propTypes = {
  buttonLabel: PropTypes.string,
};

export default FAQHeader;
